import { useConfig } from './useConfig';
export function useLocale(key) {
  var locale = useConfig().locale;
  return locale[key];
}